// Reveal.js
// Fades a block up into place the first time it scrolls into view.

import React from 'react';
import { motion } from 'motion/react';
import { fadeUpVariants } from './variants';

const Reveal = ({
    children,
    as = 'div',
    className,
    y = 24,
    duration = 0.6,
    delay = 0,
    amount = 0.2,
    once = true,
    ...rest
}) => {
    const Component = motion[as];

    return (
        <Component
            className={className}
            variants={fadeUpVariants(y, duration, delay)}
            initial="hidden"
            whileInView="show"
            viewport={{ once, amount }}
            {...rest}
        >
            {children}
        </Component>
    );
};

export default Reveal;
